import { Box, Skeleton, styled } from '@mui/material';
import React from 'react';

// 自定义样式的Skeleton
const SimpleTextSkeleton = styled(Skeleton)(() => ({
  backgroundColor: '#eeeeee',
  borderRadius: '4px',
  transform: 'scale(1, 1)',
  '&::after': {
    background: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.06), transparent)',
  },
}));

const ButtonSkeleton = styled(Skeleton)(() => ({
  borderRadius: '4px',
  '&::after': {
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)',
  },
}));

const SkeletonLoader: React.FC = () => {
  return (
    <Box className="relative">
      {/* 左侧图片骨架 - 简单灰色方块 */}
      <Box className="top-0 left-0 absolute w-[400px] h-[400px]">
        <SimpleTextSkeleton variant="rectangular" width="100%" height="100%" animation="wave" />
      </Box>

      {/* 右侧内容骨架 */}
      <Box className="relative pl-[432px] pr-[32px] h-[416px] overflow-y-auto">
        {/* 标题骨架 */}
        <SimpleTextSkeleton
          variant="rectangular"
          width="80%"
          height={36}
          animation="wave"
          sx={{ mb: 2 }}
        />

        {/* SKU和颜色信息骨架 */}
        <Box className="flex gap-6 mb-[10px]">
          <SimpleTextSkeleton variant="rectangular" width="35%" height={16} animation="wave" />
          <SimpleTextSkeleton variant="rectangular" width="35%" height={16} animation="wave" />
        </Box>

        {/* Redeemed item 骨架 */}
        <Box className="mb-10">
          <SimpleTextSkeleton variant="rectangular" width="45%" height={18} animation="wave" />
        </Box>

        <Box className="border-t border-gray-100 my-20" />

        {/* 标题 */}
        <Skeleton variant="rectangular" width="100%" height={180} animation="wave" />

        {/* 底部按钮骨架 */}
        <Box className="absolute bottom-0 right-32 bg-white py-4 flex justify-between items-center w-[368px]">
          <ButtonSkeleton variant="rectangular" width={368} height={48} animation="wave" />
        </Box>
      </Box>
    </Box>
  );
};

export default SkeletonLoader;
